import { useEffect, useState } from "react";

/**
 * Custom hook to get the current window size.
 *
 * @returns {Object} An object containing the current width and height of the window.
 * @property {number} width - The current width of the window.
 * @property {number} height - The current height of the window.
 */
const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return windowSize;
};

export default useWindowSize;
